import { Component, OnInit, ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { banner } from '../models/banner';
import { ImageCompressService } from 'ng2-image-compress';
import { ExcelService } from '../service/tableUtility.service';
// import {  FileUploadModule  } from 'ng2-file-upload';
import{FileUploader} from 'ng2-file-upload';
@Component({
  selector: 'app-bannermanagement',
  templateUrl: './bannermanagement.component.html',
  styleUrls: ['./bannermanagement.component.css']
})
export class BannermanagementComponent implements OnInit {
  public uploader:FileUploader
  albumName: any;
  usr:number
  bannerAddObj: banner
  bannerUpdateObj: banner

  show: boolean = false
  image = { 'URL': '', 'valid': false };
myurl:string;
tableData: [] = [];
images=[]
userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any
  dataSource: any;
  ipath:any
  pic:any
  picUpdate:any
  displayedColumns = [ 'screenName', 'bannerImages','status','dateOfCreation','dateOfModification', 'Action']
  @ViewChild("banner") form: any;
  @ViewChild("bannerUpdate") formUpdate: any;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // editor = ClassicEditor;
  constructor(private cs: CucurachaAdminService, private toastr: ToastrManager, private excelService: ExcelService) {
    this.bannerAddObj = new banner()
    this.bannerUpdateObj = new banner()

    this.myurl = this.cs.endpoint;

  }
 
addBanner(){
  this.pic = ""

  if(this.show==false){
    this.show=true
    this.form.reset()

  }
  else{
    this.show=false
    this.form.reset()

  }
}

 
fileChangeEvent(fileInput: any) {
  ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
    observableImages.subscribe((image) => {
      this.image.URL = image.compressedImage.imageDataUrl;
      this.bannerAddObj.images = image.compressedImage.imageDataUrl;
      this.bannerAddObj.images = this.bannerAddObj.images.replace("data:image/gif;base64,", "");
      this.bannerAddObj.images = this.bannerAddObj.images.replace("data:image/jpeg;base64,", "");
      this.bannerAddObj.images = this.bannerAddObj.images.replace("data:image/jpg;base64,", "");
      this.bannerAddObj.images = this.bannerAddObj.images.replace("data:image/png;base64,", "");
      this.pic=image.compressedImage.imageDataUrl;
    }, (error) => {
      this.toastr.errorToastr("Error while converting");
    });
  });
}
fileChangeEventUpdate(fileInput: any) {
  ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
    observableImages.subscribe((image) => {
      this.image.URL = image.compressedImage.imageDataUrl;
      this.bannerUpdateObj.images = image.compressedImage.imageDataUrl;
      this.bannerUpdateObj.images = this.bannerUpdateObj.images.replace("data:image/gif;base64,", "");
      this.bannerUpdateObj.images = this.bannerUpdateObj.images.replace("data:image/jpeg;base64,", "");
      this.bannerUpdateObj.images = this.bannerUpdateObj.images.replace("data:image/jpg;base64,", "");
      this.bannerUpdateObj.images = this.bannerUpdateObj.images.replace("data:image/png;base64,", "");
      this.picUpdate=image.compressedImage.imageDataUrl;
    }, (error) => {
      this.toastr.errorToastr("Error while converting");
    });
  });
}
applyFilter(filterValue: string) {
  filterValue = filterValue.trim();
  filterValue = filterValue.toLowerCase();
  this.dataSource.filter = filterValue;
}
saveBanner(){


  // if (sessionStorage.getItem('user') != null) {
  //     this.albumName = 'albm_' + this.bannerAddObj.screenName
  //   this.ipath = 'http://localhost:4500/file/upload/'+this.albumName ;
  //   console.log(this.ipath)
  //   this.uploader = new FileUploader({ url: this.ipath});
  //   this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
  //     item.remove();
  //     this.toastr.successToastr("Uploaded Sucessfully")
  // };
  // this.uploader.onAfterAddingFile = f => {
  //   if (this.uploader.queue.length > 10) {
  //   this.uploader.removeFromQueue(this.uploader.queue[0]);
  //   this.toastr.errorToastr("Only 10 Files are allowed")
  //   }
  //   };
//   })
// }

  this.cs.saveBanner(this.bannerAddObj).subscribe((data) => {
    if(data.result ){
      this.getAllBanners();
      this.toastr.successToastr(data.message);
      this.form.reset();
      this.pic = ""

      }
     else if(data.err){
      this.toastr.warningToastr(data.message);

     }
      else{
        this.toastr.errorToastr(data.message);

      }
  })
}
getAllBanners(){
this.cs.getAllBanners().subscribe((data) => {
  console.log(data)
  this.dataSource = new MatTableDataSource(data)
  this.dataSource.sort = this.sort
  this.dataSource.paginator = this.paginator
})

}
getBannerById(id:any){
  this.cs.getBannerById(id).subscribe((data) => {
    this.bannerUpdateObj._id = data[0]._id;

    this.bannerUpdateObj.screenId = data[0].screenId
    this.bannerUpdateObj.screenName = data[0].screenName
    this.picUpdate=this.myurl+'Misc/Images/bannerImages/'+data[0]._id
  })
}
updateBanner(){
  this.cs.updateBanner(this.bannerUpdateObj).subscribe((data) => {
    if(data.result ){
      this.getAllBanners();
      this.toastr.infoToastr(data.message);
      this.formUpdate.reset();
      
      }
     else if(data.err){
      this.toastr.warningToastr(data.message);

     }
      else{
        this.toastr.errorToastr(data.message);

      }
  })
}
deleteByBannerId(id:any){
  this.cs.deleteByBannerId(id).subscribe((data) => {
    this.getAllBanners()
    this.toastr.warningToastr("Data  Deleted");
  })
}
exportTable(){
  // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
  this.tableData = (this.dataSource.filteredData)
  console.log(this.tableData)
  this.excelService.exportAsExcelFile(this.tableData, 'Banner');
}
onChange(status, id) {
  console.log(status.checked)
  this.cs.getBannerById(id).subscribe((data) => {
    this.bannerAddObj._id = data[0]._id;
 
    this.bannerAddObj.status = status.checked;

    this.cs.updateBannerStatus(this.bannerAddObj).subscribe((data) => {
      if(data.result ){
        this.ngOnInit();
        this.toastr.successToastr(data.message);
        this.form.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  })
}
ngOnInit(): void {
  this.ipath = this.myurl + '/file/upload/' + this.usr + '/' + this.albumName;
  // this.uploader = new FileUploader({ url: this.ipath });
  this.getAllBanners();
  this.userSessionData = (JSON.parse(localStorage.getItem('user')))

  this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
    this.userDetails=data[0]
    this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].banner_management.permissions[0].read);
    this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].banner_management.permissions[0].write)
    this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].banner_management.permissions[0].delete);
    console.log(this.read,this.write)
  })
}

}
